const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Home = () => import('~/pages/home').then(m => m.default || m)
const General = () => import('~/pages/institutions/general/edit').then(m => m.default || m)
const Publications = () => import('~/pages/publications').then(m => m.default || m)
const BlogPosts = () => import('~/pages/blog/index').then(m => m.default || m)
const BlogPostsList = () => import('~/pages/blog/list').then(m => m.default || m)
const BlogPostsCreate = () => import('~/pages/blog/create').then(m => m.default || m)
const BlogPostsEdit = () => import('~/pages/blog/edit').then(m => m.default || m)

const Microscopes = () => import('~/pages/microscopes/index').then(m => m.default || m)
const MicroscopesList = () => import('~/pages/microscopes/list').then(m => m.default || m)
const MicroscopesCreate = () => import('~/pages/microscopes/create').then(m => m.default || m)
const MicroscopesEdit = () => import('~/pages/microscopes/edit').then(m => m.default || m)

const MicroscopeFilters = () => import('~/pages/microscope-filters/index').then(m => m.default || m)
const MicroscopeFiltersList = () => import('~/pages/microscope-filters/list').then(m => m.default || m)
const MicroscopeFiltersCreate = () => import('~/pages/microscope-filters/create').then(m => m.default || m)
const MicroscopeFiltersEdit = () => import('~/pages/microscope-filters/edit').then(m => m.default || m)

const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)

const Institutions = () => import('~/pages/institutions/index').then(m => m.default || m)
const ListInstitutions = () => import('~/pages/institutions/list').then(m => m.default || m)
const AddInstitution = () => import('~/pages/institutions/add').then(m => m.default || m)
const EditInstitution = () => import('~/pages/institutions/edit').then(m => m.default || m)
const EditInstitutionContents = () => import('~/pages/institutions/contents/edit').then(m => m.default || m)
const EditInstitutionPublications = () => import('~/pages/institutions/publications/edit.vue').then(m => m.default || m)

const InstitutionBlogPosts = () => import('~/pages/institutions/blog/index').then(m => m.default || m)
const InstitutionBlogPostsList = () => import('~/pages/institutions/blog/list').then(m => m.default || m)
const InstitutionBlogPostsCreate = () => import('~/pages/institutions/blog/create').then(m => m.default || m)
const InstitutionBlogPostsEdit = () => import('~/pages/institutions/blog/edit').then(m => m.default || m)

const InstitutionMicroscopes = () => import('~/pages/institutions/microscopes/index').then(m => m.default || m)
const InstitutionMicroscopesList = () => import('~/pages/institutions/microscopes/list').then(m => m.default || m)
const InstitutionMicroscopesCreate = () => import('~/pages/institutions/microscopes/create').then(m => m.default || m)
const InstitutionMicroscopesEdit = () => import('~/pages/institutions/microscopes/edit').then(m => m.default || m)

const InstitutionMicroscopeFilters = () => import('~/pages/institutions/microscope-filters/index').then(m => m.default || m)
const InstitutionMicroscopeFiltersList = () => import('~/pages/institutions/microscope-filters/list').then(m => m.default || m)
const InstitutionMicroscopeFiltersCreate = () => import('~/pages/institutions/microscope-filters/create').then(m => m.default || m)
const InstitutionMicroscopeFiltersEdit = () => import('~/pages/institutions/microscope-filters/edit').then(m => m.default || m)

const Approvals = () => import('~/pages/approvals/index').then(m => m.default || m)
const ListApprovals = () => import('~/pages/approvals/list').then(m => m.default || m)

const Users = () => import('~/pages/users/index').then(m => m.default || m)
const ListUsers = () => import('~/pages/users/list').then(m => m.default || m)
const AddUser = () => import('~/pages/users/add').then(m => m.default || m)
const EditUser = () => import('~/pages/users/edit').then(m => m.default || m)

export default [
    { path: '/', redirect: { name: 'home' } },

    { path: '/login', name: 'login', component: Login },
    { path: '/password/reset', name: 'password.request', component: PasswordEmail },
    { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

    { path: '/home', name: 'home', component: Home },
    { path: '/general', name: 'general', component: General },
    { path: '/publications', name: 'publications', component: Publications },
    {
        path: '/blog',
        component: BlogPosts,
        children: [
            { path: '', name: 'blog', redirect: { name: 'blog.list' } },
            {
                path: 'list',
                name: 'blog.list',
                component: BlogPostsList
            },
            {
                path: ':institution_id/create',
                name: 'blog.create',
                component: BlogPostsCreate
            },
            {
                path: ':institution_id/edit/:blog_post_id',
                name: 'blog.edit',
                component: BlogPostsEdit
            },
        ]
    },

    {
        path: '/microscopes',
        component: Microscopes,
        children: [
            { path: '', name: 'microscopes', redirect: { name: 'microscopes.list' } },
            {
                path: 'list',
                name: 'microscopes.list',
                component: MicroscopesList
            },
            {
                path: ':institution_id/create',
                name: 'microscopes.create',
                component: MicroscopesCreate
            },
            {
                path: ':institution_id/edit/:microscope_id',
                name: 'microscopes.edit',
                component: MicroscopesEdit
            },
        ]
    },

    {
        path: '/microscope-filters',
        component: MicroscopeFilters,
        children: [
            { path: '', name: 'microscope-filters', redirect: { name: 'microscope-filters.list' } },
            {
                path: 'list',
                name: 'microscope-filters.list',
                component: MicroscopeFiltersList
            },
            {
                path: ':institution_id/create',
                name: 'microscope-filters.create',
                component: MicroscopeFiltersCreate
            },
            {
                path: ':institution_id/edit/:microscope_filter_id',
                name: 'microscope-filters.edit',
                component: MicroscopeFiltersEdit
            },
        ]
    },

    {
        path: '/settings',
        component: Settings,
        children: [
            { path: '', redirect: { name: 'settings.profile' } },
            { path: 'profile', name: 'settings.profile', component: SettingsProfile },
            { path: 'password', name: 'settings.password', component: SettingsPassword }
        ]
    },

    {
        path: '/institutions',
        component: Institutions,
        children: [
            { path: '', redirect: { name: 'institutions.list' } },
            { path: 'list', name: 'institutions.list', component: ListInstitutions },
            { path: 'add', name: 'institutions.add', component: AddInstitution },
            { path: ':institution_id/edit', name: 'institutions.edit', component: EditInstitution },
            {
                path: ':institution_id/contents/edit',
                name: 'institutions.contents.edit',
                component: EditInstitutionContents
            },
            {
                path: ':institution_id/publications/edit',
                name: 'institutions.publications.edit',
                component: EditInstitutionPublications
            },
            {
                path: ':institution_id/blog',
                name: 'institutions.blog',
                component: InstitutionBlogPosts,
                children: [
                    {
                        path: 'list',
                        name: 'institutions.blog.list',
                        component: InstitutionBlogPostsList
                    },
                    {
                        path: 'create',
                        name: 'institutions.blog.create',
                        component: InstitutionBlogPostsCreate
                    },
                    {
                        path: ':blog_post_id/edit',
                        name: 'institutions.blog.edit',
                        component: InstitutionBlogPostsEdit
                    },

                ]
            },
            {
                path: ':institution_id/microscopes',
                name: 'institutions.microscopes',
                component: InstitutionMicroscopes,
                children: [
                    {
                        path: 'list',
                        name: 'institutions.microscopes.list',
                        component: InstitutionMicroscopesList
                    },
                    {
                        path: 'create',
                        name: 'institutions.microscopes.create',
                        component: InstitutionMicroscopesCreate
                    },
                    {
                        path: ':microscope_id/edit',
                        name: 'institutions.microscopes.edit',
                        component: InstitutionMicroscopesEdit
                    },

                ]
            },
            {
                path: ':institution_id/microscope-filters',
                name: 'institutions.microscope-filters',
                component: InstitutionMicroscopeFilters,
                children: [
                    {
                        path: 'list',
                        name: 'institutions.microscope-filters.list',
                        component: InstitutionMicroscopeFiltersList
                    },
                    {
                        path: 'create',
                        name: 'institutions.microscope-filters.create',
                        component: InstitutionMicroscopeFiltersCreate
                    },
                    {
                        path: ':microscope_filter_id/edit',
                        name: 'institutions.microscope-filters.edit',
                        component: InstitutionMicroscopeFiltersEdit
                    },

                ]
            },

        ]
    },

    {
        path: '/approvals',
        component: Approvals,
        children: [
            { path: '', redirect: { name: 'approvals.list' } },
            { path: 'list', name: 'approvals.list', component: ListApprovals }
        ]
    },

    {
        path: '/users',
        component: Users,
        children: [
            { path: '', redirect: { name: 'users.list' } },
            { path: 'list', name: 'users.list', component: ListUsers },
            { path: 'add', name: 'users.add', component: AddUser },
            { path: ':user_id/edit', name: 'users.edit', component: EditUser }
        ]
    },

    { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js